import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class WeightGridScenario extends BasicScenario {
manageKeys: boolean | null;
manageLines: boolean | null;
}

